<template>
  <b-row v-if="sessions.length > 0">
    <b-col lg="4">
      <phishing-timeline
        id="timeline-module"
        class="mt-1"
        :sessions="orderedSessions"
        :controls="false"
        :selectable="true"
        :selected="this.session.surveyEntityId"
        @select="select"
      />
    </b-col>
    <b-col lg="8">
      <b-card no-body class="card card-custom card-stretch">
        <div class="card-header border-0">
          <h3 class="card-title font-weight-bolder text-dark text-left pt-5">
            <div class="card-label font-weight-bolder text-dark-75">
              {{ this.session.campaign }}
              <div class="font-size-sm text-muted mt-2">
                {{ this.session.campaignCategory }}
              </div>
            </div>
          </h3>
        </div>
        <div class="card-body">
          <div class="timeline timeline-3" v-if="session !== false">
            <div class="timeline-items">
              <div
                class="timeline-item"
                v-for="dimension in session.dimensions"
                :key="dimension.campaignId"
              >
                <div class="timeline-media">
                  <i
                    :class="
                      `text-${dimension.value ? dimension.class : 'disabled'} ${
                        dimension.icon
                      }`
                    "
                  ></i>
                  <span
                    :class="
                      `svg-icon svg-icon-2x svg-icon-${
                        dimension.value ? dimension.class : 'disabled'
                      }`
                    "
                  >
                    <simple-svg
                      :src="require(`@/assets/images/icons/${dimension.icon}`)"
                    />
                  </span>
                </div>
                <div
                  :class="
                    `timeline-content ${
                      dimension.value ? 'bg-' + dimension.class + '-o-30' : ''
                    }`
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between mb-3"
                  >
                    <div class="mr-2">
                      <span
                        :class="
                          `text-dark-75 ${
                            dimension.value ? 'font-weight-boldest' : ''
                          }`
                        "
                      >
                        {{
                          $tc(
                            `messages.tables.dimensionIds.${dimension.id}.title`
                          )
                        }}
                      </span>
                      <!-- <span class="text-muted ml-2">8:30PM 20 June</span> -->
                      <!-- <span
                        :class="
                          `label label-light-${dimension.class} font-weight-bolder label-inline ml-2`
                        "
                        >pending</span
                      > -->
                    </div>
                  </div>
                  <p class="p-0 text-left" v-if="dimension.value">
                    {{
                      $t(
                        `messages.tables.dimensionIds.${dimension.id}.description.true`,
                        { user: user.name }
                      )
                    }}
                  </p>
                  <p class="p-0 text-left" v-else>
                    {{
                      $t(
                        `messages.tables.dimensionIds.${dimension.id}.description.false`,
                        { user: user.name }
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="200" viewBox="0 0 250 200" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="c" fill-rule="evenodd" d="M28.132 59.494C30.77 59.98 33.5 60 33.5 60 48.136 60 60 48.136 60 33.5S48.136 7 33.5 7c-3.76 0-7.336.783-10.576 2.195A26.604 26.604 0 009.896 21.442 26.388 26.388 0 007 33.5a26.402 26.402 0 006.684 17.596"/><path id="a" fill-rule="evenodd" d="M65.146 72.768a6.097 6.097 0 018.622-8.622l11.086 11.086a6.097 6.097 0 01-8.622 8.622L65.146 72.768z"/><circle id="b" cx="33.5" cy="33.5" r="33.5"/><mask id="d" x="-87" y="-66" maskContentUnits="userSpaceOnUse" maskUnits="userSpaceOnUse"><path d="M-87-66h250v200H-87z"/><use fill="#fff" xlink:href="#a"/></mask></defs><path fill="#F3F7FF" fill-rule="evenodd" d="M176 135H93a7 7 0 110-14H54a7 7 0 110-14h40a7 7 0 100-14H69a7 7 0 110-14h40a7 7 0 110-14h98a7 7 0 110 14h-40a7 7 0 110 14h22a7 7 0 110 14h-10.174c-4.874 0-8.826 3.134-8.826 7s6 7 6 7a7 7 0 110 14zm38-35a7 7 0 11-14 0 7 7 0 0114 0z"/><g transform="translate(87 66)"><use fill="#F3F7FF" xlink:href="#b"/><use fill-opacity="0" stroke="#75A4FE" stroke-width="2.5" xlink:href="#b"/></g><g transform="translate(87 66)"><use fill="#FFF" xlink:href="#c"/><use fill-opacity="0" stroke="#75A4FE" stroke-linecap="round" stroke-width="2.5" xlink:href="#c"/></g><path fill="none" stroke="#75A4FE" stroke-linecap="round" stroke-width="2.5" d="M103.797 120.075a26.473 26.473 0 007.204 4.172"/><path fill="none" stroke="#A4C3FE" stroke-linecap="round" stroke-width="2.5" d="M121 81c-1.723 0-3.392.23-4.979.659C107.943 83.847 102 91.229 102 100"/><path fill="none" stroke="#75A4FE" stroke-width="2.5" d="M148 126l6 6"/><g transform="translate(87 66)"><use fill="#E8F0FE" xlink:href="#a"/><use fill-opacity="0" stroke="#75A4FE" stroke-width="5" mask="url(#d)" xlink:href="#a"/></g><path fill="none" stroke="#FFF" stroke-linecap="round" stroke-width="2.5" d="M158 133l11 11"/></svg>
            <h2 v-html="$t('messages.campaigns.emptyDetail')" />
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
  <b-row class="mt-9" v-else>
    <b-col>
      <empty-card type="user.phishing" />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import _ from "lodash";

import { getStakeholderCampaigns, getEntityProfile } from "@/api/campaigns.api";
import { extractValueFromProfile } from "@/utils/helpers";

import EmptyCard from "@/components/EmptyCard.component";
import PhishingTimeline from "@/components/dashboard/PhishingTimeline.component";
import { SimpleSVG } from "vue-simple-svg";

export default {
  name: "Phishing",
  props: {
    stakeholderId: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    EmptyCard,
    PhishingTimeline,
    "simple-svg": SimpleSVG
  },
  data() {
    return {
      phishing: {},
      session: false,
      sessions: [],
      profile: {},
      phishingTypes: []
    };
  },
  computed: {
    ...mapGetters("Constants", ["getConstant"]),
    activeDimensions() {
      return _.filter(
        this.session.dimensions,
        dim => dim.value === true || dim.value === 1
      );
    },
    orderedSessions() {
      return _.orderBy(
        this.sessions,
        [
          o => {
            return moment(o.userStartDate).format("x");
          }
        ],
        ["desc"]
      );
    }
  },
  methods: {
    select(session) {
      this.session = false;
      var cyberProfile = {
        groupDimensions: [this.getConstant("DIMENSION_GROUP_PHISHING")],
        surveyEntities: [session.surveyEntityId]
      };
      getEntityProfile(session.campaignId, cyberProfile).then(profileResp => {
        var dimensions = [
          {
            name: "DIMENSION_ELEMENT_PHISHING_EMAIL_SENT",
            class: "success",
            icon: "sending.svg"
          },
          {
            name: "DIMENSION_ELEMENT_PHISHING_EMAIL_OPENED",
            class: "info",
            icon: "mail-opened.svg"
          },
          {
            name: "DIMENSION_ELEMENT_PHISHING_CLICKED_LINK",
            class: "warning",
            icon: "cursor.svg"
          },
          {
            name: "DIMENSION_ELEMENT_PHISHING_SUBMITTED_DATA",
            class: "danger",
            icon: "write.svg"
          },
          {
            name: "DIMENSION_ELEMENT_PHISHING_EMAIL_REPORTED",
            class: "primary",
            icon: "spam.svg"
          }
        ];
        session.dimensions = [];
        _.each(dimensions, dimension => {
          var dim = extractValueFromProfile(
            profileResp.data.records,
            "DIMENSION_GROUP_PHISHING",
            session.surveyTypeId,
            "dimensionValue",
            false,
            dimension.name,
            session.surveyEntityId,
            false,
            true
          );
          if (dimension.name !== "DIMENSION_ELEMENT_PHISHING_EMAIL_REPORTED") {
            session.dimensions.push({
              id: parseInt(this.getConstant(dimension.name)),
              class: dimension.class,
              icon: dimension.icon,
              value: dim.dimensionValue
            });
          } else if (dimension.value === true || dimension.value === 1) {
            session.dimensions.push({
              id: parseInt(this.getConstant(dimension.name)),
              class: dimension.class,
              icon: dimension.icon,
              value: dim.dimensionValue
            });
          }
        });
        this.session = session;
      });
    }
  },
  mounted() {
    getStakeholderCampaigns(this.stakeholderId, { filterDate: false }).then(
      campaignsResp => {
        this.sessions = campaignsResp.data.records;
      }
    );
  }
};
</script>

<style lang="scss">
.timeline.timeline-3 .timeline-items .timeline-item {
  .bg-success-o-30.timeline-content:before {
    border-right: solid 8px rgba(27, 197, 189, 0.12);
  }
  .bg-info-o-30.timeline-content:before {
    border-right: solid 8px rgba(137, 80, 252, 0.12);
  }
  .bg-warning-o-30.timeline-content:before {
    border-right: solid 8px rgba(255, 168, 0, 0.12);
  }
  .bg-danger-o-30.timeline-content:before {
    border-right: solid 8px rgba(246, 78, 96, 0.12);
  }
}
</style>
